import { createReducer, on } from '@ngrx/store';

import { UpdateStatus } from '@shared/enums/update-status';
import { RestBidModel } from '@shared/interfaces/bid.interface';
import { RestBulkScopeAndBidModel } from '@shared/interfaces/rest-bulk-scope-and-bid-model';

import {
  addUnitsToBulk,
  addUnitsToBulkSuccess,
  createNewBulkScope,
  createNewBulkScopeFailed,
  createNewBulkScopeSuccess,
  getBulkScope,
  getBulkScopeFailed,
  getBulkScopeList,
  getBulkScopeListFailed,
  getBulkScopeListSuccess,
  getBulkScopeSuccess,
  resetNewBulkScopeID,
  resetUpdateBulkScopeStatus,
  updateBulkScope,
  updateBulkScopeFailed,
  updateBulkScopeSuccess,
} from '../actions/bulk-and-scope.actions';

export const bulkBidsFeatureKey = 'bulk-bids';

export interface State {
  newBulkScopeInProgress: boolean;
  newBulkScopeInStatus: UpdateStatus;
  newBulkScopeInId: number;

  bulkScopeLoading: boolean;
  bulkScope: RestBulkScopeAndBidModel;

  bulkScopeListLoading: boolean;
  bulkScopeList: RestBulkScopeAndBidModel[];

  updateBulkScopeInProgress: boolean;
  updateBulkScopeInStatus: UpdateStatus;

  allBidList: RestBidModel[];
  allBidListLoading: boolean;

  addUnitsInProgress: boolean;
}

export const initialState: State = {
  newBulkScopeInProgress: false,
  newBulkScopeInStatus: null,
  newBulkScopeInId: null,

  bulkScopeLoading: false,
  bulkScope: null,

  bulkScopeListLoading: false,
  bulkScopeList: [],

  updateBulkScopeInProgress: false,
  updateBulkScopeInStatus: null,

  allBidList: [],
  allBidListLoading: false,
  addUnitsInProgress: false,
};

export const reducer = createReducer(
  initialState,

  /**
   * Create new bulk scope
   */
  on(createNewBulkScope, (state, action) => ({
    ...state,
    newBulkScopeInProgress: true,
    newBulkScopeInStatus: UpdateStatus.UPDATE,
    newBulkScopeInId: null,
  })),
  on(createNewBulkScopeSuccess, (state, action) => ({
    ...state,
    newBulkScopeInProgress: false,
    newBulkScopeInStatus: UpdateStatus.OK,
    newBulkScopeInId: action.bulkScopeId,
  })),
  on(createNewBulkScopeFailed, (state, action) => ({
    ...state,
    newBulkScopeInProgress: false,
    newBulkScopeInStatus: UpdateStatus.ERROR,
    newBulkScopeInId: null,
  })),
  on(resetNewBulkScopeID, (state, action) => ({
    ...state,
    newBulkScopeInId: null,
  })),

  /**
   * get bulk scope
   */
  on(getBulkScope, (state, action) => ({
    ...state,
    bulkScopeLoading: true,
  })),
  on(getBulkScopeSuccess, (state, action) => ({
    ...state,
    bulkScope: action.bulkScope,
    bulkScopeLoading: false,
  })),
  on(getBulkScopeFailed, (state, action) => ({
    ...state,
    bulkScope: null,
    bulkScopeLoading: false,
  })),
  /**
   * get bulk scope list
   */
  on(getBulkScopeList, (state, action) => ({
    ...state,
    bulkScopeListLoading: true,
  })),
  on(getBulkScopeListSuccess, (state, action) => ({
    ...state,
    bulkScopeList: action.bulkList,
    bulkScopeListLoading: false,
  })),
  on(getBulkScopeListFailed, (state, action) => ({
    ...state,
    bulkScopeList: [],
    bulkScopeListLoading: false,
  })),

  /**
   * update bulk scope
   */
  on(updateBulkScope, (state, action) => ({
    ...state,
    updateBulkScopeInStatus: UpdateStatus.UPDATE,
    updateBulkScopeInProgress: true,
  })),
  on(updateBulkScopeSuccess, (state, action) => ({
    ...state,
    updateBulkScopeInStatus: UpdateStatus.OK,
    updateBulkScopeInProgress: false,
  })),
  on(updateBulkScopeFailed, (state, action) => ({
    ...state,
    updateBulkScopeInStatus: UpdateStatus.ERROR,
    updateBulkScopeInProgress: false,
  })),
  on(resetUpdateBulkScopeStatus, (state, action) => ({
    ...state,
    updateBulkScopeInStatus: null,
  })),

  /**
   * add units to bulk
   */
  on(addUnitsToBulk, (state, action) => ({
    ...state,
    addUnitsInProgress: true,
  })),
  on(addUnitsToBulkSuccess, updateBulkScopeFailed, (state, action) => ({
    ...state,
    addUnitsInProgress: false,
  }))
);
